module.exports = __webpack_public_path__ + "media/images/icons/material/chevron-down-b3c6ebaf49aeb7739bc29f846fe20dd9.svg";